import { Button, Form } from 'react-bootstrap';
import { LOW_AVAILABLE_ROOM_WARNING } from '../common/constants';
import { Loader } from '../controls/Loader';
import { StyledCardTitle } from '../pages/Review.styled';
import {
  StyledRoomDescription,
  StyledRoomPrice,
  StyledNotAvailableText,
  StyledOriginalPrice,
} from '../pages/Search.styled';
import { IHotelAvailability, IRoomInfo } from '../types/hotelTypes';
import { formatCurrency } from '../utils/numberUtil';
import { RoomActions, StyledRoomSearchResult, StyledSearchContent, StyledSearchGrid } from './RoomSearchResult.styled';
import { RoomImageSlider } from '../controls/RoomImageSlider';

interface IProps {
  roomInfo: IRoomInfo;
  searchResult?: IHotelAvailability;
  isLoading?: boolean;
  onSelect?: (roomTypeId: number) => void;
}

export const RoomSearchResult = ({ isLoading, roomInfo, searchResult, onSelect }: IProps) => {
  if (!roomInfo) {
    return null;
  }

  const selectRoom = (roomTypeId: number) => {
    onSelect?.(roomTypeId);
  };

  return (
    <StyledRoomSearchResult>
      <RoomImageSlider images={roomInfo.roomImages} />
      <StyledSearchGrid>
        <StyledSearchContent>
          <StyledCardTitle>{roomInfo.roomTypeName}</StyledCardTitle>
          <StyledRoomDescription>{roomInfo.roomDescription}</StyledRoomDescription>
        </StyledSearchContent>
        {isLoading && (
          <RoomActions>
            <Loader overlay={false} />
          </RoomActions>
        )}
        {!isLoading && Boolean(searchResult?.TotalPrice) && (
          <RoomActions>
            {searchResult.TotalOriginalPrice > searchResult.TotalPrice && (
              <StyledOriginalPrice>{formatCurrency(searchResult.TotalOriginalPrice)}</StyledOriginalPrice>
            )}
            <StyledRoomPrice>{formatCurrency(searchResult.TotalPrice)}</StyledRoomPrice>
            {searchResult.AvailableRooms > 0 && (
              <div>
                <div>
                  <Button onClick={() => selectRoom(roomInfo.roomTypeId)}>Chọn phòng</Button>
                </div>
                {searchResult.AvailableRooms <= LOW_AVAILABLE_ROOM_WARNING && (
                  <Form.Text>
                    {`Chỉ còn `} <span className="room-availablity">{searchResult.AvailableRooms}</span> {`phòng trống`}
                  </Form.Text>
                )}
              </div>
            )}
            {searchResult.AvailableRooms <= 0 && (
              <StyledNotAvailableText>
                <Button variant="outline-danger" disabled>
                  Hết Phòng
                </Button>
              </StyledNotAvailableText>
            )}
          </RoomActions>
        )}
      </StyledSearchGrid>
    </StyledRoomSearchResult>
  );
};
